import * as React from "react";

const SvgIcnHoldLargeBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="currentColor" fillRule="nonzero">
            <path d="M5 3h4a1 1 0 011 1v16a1 1 0 01-1 1H5a1 1 0 01-1-1V4a1 1 0 011-1zM14 3h4a1 1 0 011 1v16a1 1 0 01-1 1h-4a1 1 0 01-1-1V4a1 1 0 011-1z" />
        </g>
    </svg>
);

export default SvgIcnHoldLargeBold;
